import { route as ziggyRoute } from "ziggy-js";

function buildZiggyConfig(ziggy) {
    if (!ziggy?.routes) {
        return null;
    }

    let location = ziggy.location;

    if (!(location instanceof URL)) {
        const href =
            location ??
            (typeof window !== "undefined"
                ? window.location.href
                : ziggy.url);

        location = new URL(href);
    }

    return {
        ...ziggy,
        location,
    };
}

/**
 * Ziggy uses encodeURI, which leaves # ? & unencoded. Those characters break
 * path parameters (e.g. usernames like "Praynow#1"), so pre-encode them.
 */
export function encodeReservedRouteParamChars(value) {
    if (typeof value === "string") {
        return value
            .replace(/#/g, "%23")
            .replace(/\?/g, "%3F")
            .replace(/&/g, "%26");
    }

    if (Array.isArray(value)) {
        return value.map((item) => encodeReservedRouteParamChars(item));
    }

    return value;
}

export function encodeRouteParams(params) {
    if (params == null) {
        return params;
    }

    if (typeof params === "string" || typeof params === "number") {
        return encodeReservedRouteParamChars(String(params));
    }

    if (Array.isArray(params)) {
        return params.map((item) => encodeReservedRouteParamChars(item));
    }

    if (typeof params !== "object") {
        return params;
    }

    return Object.fromEntries(
        Object.entries(params).map(([key, value]) => [
            key,
            encodeReservedRouteParamChars(value),
        ]),
    );
}

export function configureZiggy(ziggy) {
    const config = buildZiggyConfig(ziggy);

    if (!config) {
        return;
    }

    globalThis.Ziggy = config;
    globalThis.route = (name, params, absolute) =>
        ziggyRoute(name, encodeRouteParams(params), absolute, config);
}

export function configureZiggyFromPage(page) {
    configureZiggy(page?.props?.ziggy);
}
